"use client";

import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { ProjectStore } from "@/app/stores/ProjectStore";
import { UserStore } from "@/app/stores/UserStore";
import { PublicUser } from "@/app/types/auth/PublicUser";
import { SubscriptionOverview } from "@/app/types/billing/SubscriptionOverview";
import { ProjectLite } from "@/app/types/project/ProjectLite";
import { QueryKey } from "@/app/vars/QueryKeys";

type Props = {
  user: PublicUser | null;
  projects: ProjectLite[] | null;
  savedProjectId?: number;
  subscription: SubscriptionOverview | null;
};

export default function AppHydrator(props: Props) {
  const { user, projects, savedProjectId, subscription } = props;
  const queryClient = useQueryClient();
  const hydrated = useRef(false);

  useEffect(() => {
    if (hydrated.current) {
      return;
    }
    hydrated.current = true;

    if (user) {
      UserStore.getState().setUser(user);
      queryClient.setQueryData([QueryKey.AUTH_USER], user);
    }

    if (projects) {
      ProjectStore.getState().hydrateProjects(projects, savedProjectId);
    }

    if (subscription) {
      queryClient.setQueryData([QueryKey.SUBSCRIPTION], subscription);
    }
  }, [user, projects, savedProjectId, subscription, queryClient]);

  return null;
}
